// extracted by mini-css-extract-plugin
export default {"textDefault":"#4c6170","interactiveFocus":"#69bbd8","interactiveError":"#e10025","interactiveSuccess":"#009e55","borderRadius":"5px","maxWidthPage":"2400px"};